import Mapa from './Mapa'

export default Mapa
